
export function getToken() {
  return localStorage.getItem('token')
}

export function setToken(token: string) {
  return localStorage.setItem('token', token)
}
/** Firebase `/me` stores `id`; fallback shapes use `uid`. */
export function getAuthUserSubject(user: unknown): string | null {
  if (user && typeof user === 'object') {
    const o = user as { id?: unknown; uid?: unknown }
    const raw = o.id ?? o.uid
    if (raw != null && String(raw) !== '') return String(raw)
  }
  return getUserId()
}

export function getUserId() {
  const user = localStorage.getItem('user')

  if (!user) return null

  try {
    const parsed = JSON.parse(user) as { id?: unknown; uid?: unknown }
    const raw = parsed.id ?? parsed.uid
    return raw != null && String(raw) !== '' ? String(raw) : null
  } catch (err) {
    console.error('Invalid user JSON:', err)
    return null
  }
}

export function getUser() {
  const user = localStorage.getItem('user')
  
  if (!user) return null

  try {
    return JSON.parse(user) || null
  } catch (err) {
    console.error('Invalid user JSON:', err)
    return null
  }
}

export function removeToken() {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  return 
}
